import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=6aa8070c&scoped=true&"
import script from "./invitation.vue?vue&type=script&lang=js&"
export * from "./invitation.vue?vue&type=script&lang=js&"
import style0 from "./invitation.vue?vue&type=style&index=0&id=6aa8070c&prod&lang=scss&scoped=true&"
import style1 from "./invitation.vue?vue&type=style&index=1&id=6aa8070c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8070c",
  null
  
)

export default component.exports